import React, { Component } from 'react';
import { connect } from 'react-redux';
import OffersView from './Offers.view';
import { getGroupedOffers } from './Offers.selectors';

const initialState = {
  formState: {
    data: {},
  }
};

export class OffersContainer extends Component {

  constructor(props) {
    super(props);

    this.state = initialState;

    this.deactivateOffer = this.deactivateOffer.bind(this);
    this.activateOffer = this.activateOffer.bind(this);
    this.turnOnOffers = this.turnOnOffers.bind(this);
    this.turnOffOffers = this.turnOffOffers.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.enableOfferGroup = this.enableOfferGroup.bind(this);
    this.disableOfferGroup = this.disableOfferGroup.bind(this);
    this.removeOfferGroup = this.removeOfferGroup.bind(this);
    this.selectOfferGroup = this.selectOfferGroup.bind(this);
    this.toggleCheckboxes = this.toggleCheckboxes.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_OFFERS'
    });
  }

  submitForm(formState) {
    const { dispatch, offers } = this.props;
    const checkedOffers = [];
    offers.forEach((offer, i) => {
      if(formState.data.offers[i]) {
        checkedOffers.push(offer);
      }
    });

    const name = prompt('What is the offer group\'s name');
    if (name) {
      dispatch({
        type: 'CREATE_OFFER_GROUP',
        payload: {
          offers: checkedOffers,
          name,
        },
      });

    }
  }

  onFormUpdate(formState, action) {
    this.setState({
      formState
    });
  }

  deactivateOffer(offer_hash) {
    const { dispatch } = this.props;
    dispatch({
      type: 'DEACTIVATE_OFFER',
      payload: {
        offer_hash,
      }
    });
  }

  activateOffer(offer_hash) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ACTIVATE_OFFER',
      payload: {
        offer_hash,
      }
    });
  }

  turnOnOffers(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TURN_ON_OFFERS',
      payload: {}
    });
  }

  turnOffOffers(){
    const { dispatch } = this.props;
    dispatch({
      type: 'TURN_OFF_OFFERS',
      payload: {}
    });
  }

  enableOfferGroup(id) {
    const { dispatch, offerGroups } = this.props;
    const offerGroup = offerGroups.find(group => group._id === id);
    dispatch({
      type: 'ENABLE_OFFER_GROUP',
      payload: {
        offerGroup,
      },
    });
  }

  disableOfferGroup(id) {
    const { dispatch, offerGroups } = this.props;
    const offerGroup = offerGroups.find(group => group._id === id);
    dispatch({
      type: 'DISABLE_OFFER_GROUP',
      payload: {
        offerGroup,
      },
    });
  }

  removeOfferGroup(id) {
    const { dispatch, offerGroups } = this.props;
    const offerGroup = offerGroups.find(group => group._id === id);
    dispatch({
      type: 'REMOVE_OFFER_GROUP',
      payload: {
        offerGroup,
      },
    });
  }

  selectOfferGroup(offerGroup) {
    const { offers } = this.props;
    let { formState } = this.state;

    offers.forEach((offer, i) => {
      if(offerGroup.offers.indexOf(offer.offer_hash) > -1) {
        formState = {
          ...formState,
          data: {
            ...formState.data,
            offers: [
              ...(formState.data.offers || []).slice(0, i),
              true,
              ...(formState.data.offers || []).slice(i+1),
            ],
          },
        };
      }
    });
    this.setState({
      formState
    });

  }

  toggleCheckboxes(value) {
    const { offers } = this.props;
    let { formState } = this.state;

    this.setState({
      formState: {
        ...formState,
        data: {
          ...formState.data,
          offers: offers.map(() => value),
        }
      }
    });
  }

  render() {
    return (<OffersView
      {...this.state}
      {...this.props}
      deactivateOffer={this.deactivateOffer}
      activateOffer={this.activateOffer}
      turnOnOffers={this.turnOnOffers}
      turnOffOffers={this.turnOffOffers}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      enableOfferGroup={this.enableOfferGroup}
      disableOfferGroup={this.disableOfferGroup}
      removeOfferGroup={this.removeOfferGroup}
      selectOfferGroup={this.selectOfferGroup}
      toggleCheckboxes={this.toggleCheckboxes}
    />);
  }

}

function mapStateToProps(state) {
  const { offers } = state;
  return {
    offers: offers.offers,
    groupedOffers: getGroupedOffers(state),
    offerGroups: offers.offerGroups,
  };
}

export default connect(mapStateToProps)(OffersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Offers.container.js